// extracted by mini-css-extract-plugin
export default {"wrapper":"DocumentTypeMenu_wrapper__Z4KD7"};